import request from '@/utils/request'
//获取流程id
export const getFlowId = () => {
  return request({
    url: '/workflow/flow/flowDefinitionList',
    method: 'get',
    params: {
      pageNum: 1,
      pageSize: 1000,
    }
  })
}
// 获取申请列表
export const getFlowList = (data) => {
  return request({
    url: '/workflow/flow/list_v2',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 取消申请
export const cancelFlow = (data) => {
  return request({
    url: '/workflow/flow/cancel_v2',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 发送PDF到邮箱
export const sendEmail = (data) => {
  return request({
    url: '/workflow/form/electronicApplicationFormToEmail',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 获取网络中心用户信息
export const getNetworkCenterUserInfo = (data) => {
  return request({
    url: '/auth/getNetworkCenterUserInfo',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 获取缓考申请单列表
export const getDelayedExamFormList = (data) => {
  return request({
    url: '/workflow/delayedExam/getFormList',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 获取校医院请假单列表
export const getHisSickLeaveList = (data) => {
  return request({
    url: '/workflow/hisSickLeaveV2/getList',
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    },
    params: data
  })
}

// 上传图片
export const uploadImage = (data) => {
  return request({
    url: '/health/BackArticle/uploadImage',
    method: 'post',
    // headers: {
    //   'Content-Type': 'application/json'
    // },
    data
  })
}

// 删除图片
export const deleteImage = (data) => {
  return request({
    url: '/health/BackArticle/deleteImage',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 提交申请（新增/修改）
export const submitApplication = (data) => {
  return request({
    url: '/workflow/flow/start_v2',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 获取申请单详情
export const getApplicationFormDetail = (data) => {
  return request({
    url: '/workflow/form/getApplicationFormDetail',
    method: 'get',
    params: data
  })
}
